export const categories = [
	{ label: "Office", value: "office" },
	{ label: "Home", value: "home" },
	{ label: "On-Site", value: "on_site" },
	{ label: "Vacation", value: "vacation" },
	{ label: "Public Holidays", value: "public_holidays" },
	{ label: "Sick", value: "sick" },
	{ label: "Training", value: "training" },
]

/**
 * The project a category has to be booked against, matched on the project's
 * description.
 *
 * The rule runs one way only. Training must go to General, but General is not
 * reserved for Training - it equally serves Office, Home, On-Site and the
 * rest, which is why it is absent from `projectCategory` below: choosing the
 * project says nothing about the category.
 */
export const categoryProject: { [key: string]: string } = {
	vacation: "Vacation",
	sick: "General",
	public_holidays: "Public Holidays",
	training: "General",
};

/**
 * Of those, the categories the form refuses to submit against any other
 * project. Public Holidays is deliberately not here: its project is filled in
 * automatically but has always been left editable, and tightening that is a
 * separate decision.
 */
export const strictCategoryProjects = ["vacation", "sick", "training"];

export const projectCategory: { [key: string]: string } = {
	"61xG091": "vacation",
	// Public Holidays project may be referenced by code alone or with suffix
	"61xG090": "public_holidays",
	"61xG090_Public Holidays": "public_holidays",
};